import {
  AirLockDto,
  EquipmentDto,
  Equipment,
  EquipmentTypeDto,
  EquipmentListWrapper,
  EquipmentType,
  ExtractorDto,
} from "@/models/equipment.model";
import { http } from "./https.service";
import {
  mapAirLockDtosToAirLock,
  mapEquipmentDtosToEquipments,
  mapExtractorDtosToExtractors,
} from "./mapper.service";
import _ from 'lodash';
import Vue from "vue";
import { calculateDebitFromAbacus } from "@/services/balanceSheet.service";
import store from "@/store";
import { ElementaryZone } from "@/models/site.model";


/**
 */
interface CommonDatas<T> {
  data: T[];
  nbTotalMateriel: number;
}

/**
 * Get equipments data, filtered by equipmentType, model and constructors if provided.
 * @returns the list of equipment and the total number of equipment in all pages. The request must used pagination parameters.
 */
export async function getEquipmentsByCategoryAndModelAndConstructor(
  equipmentType: EquipmentType,
  constructor: string,
  model: string,
  page: number,
  perPage: number
): Promise<EquipmentListWrapper> {
  let httpResponse;
  switch (equipmentType) {
    case EquipmentType.workersAirLock:
      httpResponse = await getEquipmentsWithParameters<AirLockDto>(
        EquipmentTypeDto.sasPersonel,
        constructor,
        model,
        page,
        perPage
      );
      
      return {
        equipmentList: mapAirLockDtosToAirLock(httpResponse.data),
        // equipmentList: _.orderBy(mapAirLockDtosToAirLock(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
    case EquipmentType.wastesAirLock:
      httpResponse = await getEquipmentsWithParameters<AirLockDto>(
        EquipmentTypeDto.sasDechets,
        constructor,
        model,
        page,
        perPage
      );
      return {
        equipmentList: mapAirLockDtosToAirLock(httpResponse.data),
        // equipmentList: _.orderBy(mapAirLockDtosToAirLock(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
    case EquipmentType.extractor:
      httpResponse = await getEquipmentsWithParameters<ExtractorDto>(
        EquipmentTypeDto.extracteur,
        constructor,
        model,
        page,
        perPage
      );
      return {
        equipmentList: mapExtractorDtosToExtractors(httpResponse.data),
        // equipmentList: _.orderBy(mapExtractorDtosToExtractors(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
    case EquipmentType.eacm:
      httpResponse = await getEquipmentsWithParameters<EquipmentDto>(
        EquipmentTypeDto.eacm,
        constructor,
        model,
        page,
        perPage
      );
      return {
        // equipmentList: mapEquipmentDtosToEquipments(httpResponse.data),
        equipmentList: _.orderBy(mapEquipmentDtosToEquipments(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
    case EquipmentType.ear:
      httpResponse = await getEquipmentsWithParameters<EquipmentDto>(
        EquipmentTypeDto.ear,
        constructor,
        model,
        page,
        perPage
      );
      return {
        equipmentList: mapEquipmentDtosToEquipments(httpResponse.data),
        // equipmentList: _.orderBy(mapEquipmentDtosToEquipments(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
    //Search without type filter. Shouldn't happens
    default:
      httpResponse = await getEquipmentsWithParameters<EquipmentDto>(
        EquipmentTypeDto.none,
        constructor,
        model,
        page,
        perPage
      );
      
      return {
        equipmentList: mapEquipmentDtosToEquipments(httpResponse.data),
        // equipmentList: _.orderBy(mapEquipmentDtosToEquipments(httpResponse.data),['constructor','model'], ['asc', 'asc']),
        totalEquipmentCount: httpResponse.nbTotalMateriel,
      };
  }
}

/**
 * build and execute the http request to get the equipments from magnolia.
 * The type T must be coherent with typeMateriel
 * if constructor or model is empty we don't add the filter in the request.
 * @param typeMateriel mandatory parameter
 * @param constructor optional parameter
 * @param model optional parameter
 * @returns a promise of commonsDatas containing an array of T elements
 */
async function getEquipmentsWithParameters<T>(
  typeMateriel: EquipmentTypeDto,
  constructor: string,
  model: string,
  page: number,
  perPage: number
): Promise<CommonDatas<T>> {
  let requestUrlWithParameters = Vue.prototype.URL_GetEquipments.concat("?typeMateriel=", typeMateriel);
  if (constructor) {
    requestUrlWithParameters = requestUrlWithParameters.concat("&marque=", constructor);
  }
  if (model) {
    requestUrlWithParameters = requestUrlWithParameters.concat("&modele=", model);
  }
  if (page && perPage) {
    requestUrlWithParameters = requestUrlWithParameters.concat("&page=", page.toString());
    requestUrlWithParameters = requestUrlWithParameters.concat(
      "&maxResultsPerPage=",
      perPage.toString()
    );
  }
  const { data } = await http.get<CommonDatas<T>>(requestUrlWithParameters);
  return data;
}

//Ordonner par Débit
export  function  getValuesDebit(listEquipments: Equipment[], baseDepression:number) {
  listEquipments.forEach(element => {
    if(element.abacus) {
      const  valueDebit = calculateDebitFromAbacus(element.abacus,baseDepression);
      element.valueDebit= valueDebit;
    }
  });
 
  return _.orderBy((listEquipments),['valueDebit'], ['asc']);
}

//get constructors from i18n value;
export function getConstructorsList(): string[] {
  return ["Lapro", "Deconta", "Siemens", "INRS"];
}

/*Evolution Majeure composition de EACM*/
export function verifSiteEacmOptional(elementaryZone:ElementaryZone):boolean {
  let isPresent = false
  const listSitesOptional = store.state.equipmentsModule.optionalEacmsites;
  if(listSitesOptional  && listSitesOptional.length >0) {
    const findSite=listSitesOptional.findIndex((site:ElementaryZone) => site.name === elementaryZone.name);
    if(findSite !== (-1)) {
      isPresent=true;
    }
  }

  return isPresent;
}